import React from 'react';
import styles from './DispexInput.module.scss';
import cn from 'classnames';
import { Input, Tooltip } from 'antd';
import { typeKeys } from './config';

const { TextArea } = Input;

const DispexInput = ({
  value = '',
  onChange,
  placeholder,
  typeInput = typeKeys.input,
  autoSize = { minRows: 3, maxRows: 6 },
  disabled = false,
  className,
  title = '',
  ...props
}) => {
  const Component = typeInput === typeKeys.input ? Input : TextArea;

  return (
    <Tooltip title={title}>
      <Component
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        allowClear
        {...(typeInput === typeKeys.textarea ? { autoSize } : {})}
        className={cn(styles.root, className)}
        {...props}
      />
    </Tooltip>
  );
};

export default DispexInput;
